function normalizeLoopPosition(position,period){
  if(!Number.isFinite(position))return period>0?period:0;
  if(!(period>0))return Math.max(0,position);
  return period+((position-period)%period+period)%period;
}
function visibleReviewRange(left,width,step,count){
  if(!(count>0)||!(step>0))return {first:0,last:0};
  const firstSlot=Math.floor((left+8)/step);
  const lastSlot=Math.max(firstSlot,Math.ceil((left+width-8)/step)-1);
  const index=slot=>((slot%count)+count)%count+1;
  return {first:index(firstSlot),last:index(lastSlot)};
}
function createProofLoop(track,{speed,reduced,blocked,onPosition=()=>{}}){
  const originals=[...track.children];
  originals.forEach((card,index)=>card.dataset.loopIndex=index);
  function cloneGroup(){return originals.map(original=>{
    const clone=original.cloneNode(true);
    clone.dataset.clone='true';clone.setAttribute('aria-hidden','true');clone.setAttribute('tabindex','-1');
    for(const node of clone.querySelectorAll('a,button,input,select,textarea,[tabindex]'))node.setAttribute('tabindex','-1');
    for(const image of clone.querySelectorAll('img'))image.loading='lazy';
    for(const node of [clone,...clone.querySelectorAll('[id]')])node.removeAttribute('id');
    for(const node of [clone,...clone.querySelectorAll('*')])for(const attribute of [...node.attributes])if(attribute.name.startsWith('data-shopify-editor'))node.removeAttribute(attribute.name);
    return clone;
  });}
  if(originals.length>1){track.prepend(...cloneGroup());track.append(...cloneGroup());}
  let visible=false,dragging=false,press=null,momentum=0,velocity=0,suppressClickUntil=0,previousTime=0,animationFrame,period=0;
  let drift=track.scrollLeft,lastApplied=drift;
  function writePosition(position){
    drift=normalizeLoopPosition(position,period);
    track.scrollLeft=drift;lastApplied=track.scrollLeft;onPosition();
  }
  function refresh(){
    if(originals.length<2){onPosition();return;}
    const fraction=period?(drift-period)/period:0;
    period=originals[0].offsetLeft-track.firstElementChild.offsetLeft;
    if(!(period>0))return;
    while(track.scrollWidth-track.clientWidth<period*2+1)track.append(...cloneGroup());
    writePosition(period*(1+fraction));
  }
  function animate(time){
    const delta=previousTime?Math.min(time-previousTime,80):0;previousTime=time;
    if(visible&&!document.hidden&&!blocked()){
      const manualDelta=track.scrollLeft-lastApplied;
      if(Math.abs(manualDelta)>.25)drift+=manualDelta;
      if(!dragging){
        const autoSpeed=originals.length>1&&!reduced.matches?speed:0;
        drift+=delta*(autoSpeed+momentum);momentum*=Math.exp(-delta/240);
        if(Math.abs(momentum)<.001)momentum=0;
      }
      writePosition(drift);
    }else{drift=track.scrollLeft;lastApplied=drift;}
    animationFrame=requestAnimationFrame(animate);
  }
  const observer=new IntersectionObserver(entries=>visible=entries[0].isIntersecting,{rootMargin:'40px'});
  observer.observe(track);
  const sizeObserver=new ResizeObserver(refresh);sizeObserver.observe(track);
  refresh();animationFrame=requestAnimationFrame(animate);
  track.addEventListener('dragstart',event=>event.preventDefault());
  track.addEventListener('pointerdown',event=>{
    if(!event.isPrimary||event.button!==0)return;
    press={id:event.pointerId,x:event.clientX,y:event.clientY,start:drift,lastX:event.clientX,time:event.timeStamp};velocity=0;momentum=0;
  });
  track.addEventListener('pointermove',event=>{
    if(!press||press.id!==event.pointerId)return;
    if(event.pointerType==='mouse'&&event.buttons===0){finishPointer(event);return;}
    const dx=event.clientX-press.x,dy=event.clientY-press.y;
    if(!dragging&&Math.abs(dx)>6&&Math.abs(dx)>Math.abs(dy)){dragging=true;track.classList.add('is-dragging');track.setPointerCapture(event.pointerId);}
    if(!dragging)return;
    event.preventDefault();
    const elapsed=Math.max(8,event.timeStamp-press.time);
    const instantaneous=Math.max(-2.5,Math.min(2.5,(press.lastX-event.clientX)/elapsed));
    velocity=velocity*.25+instantaneous*.75;writePosition(press.start-dx);press.lastX=event.clientX;press.time=event.timeStamp;
  });
  function finishPointer(event){
    if(!press||press.id!==event.pointerId)return;
    if(dragging){momentum=velocity;suppressClickUntil=performance.now()+300;}
    dragging=false;press=null;track.classList.remove('is-dragging');
    if(track.hasPointerCapture(event.pointerId))track.releasePointerCapture(event.pointerId);
  }
  for(const event of ['pointerup','pointercancel','lostpointercapture'])track.addEventListener(event,finishPointer);
  track.addEventListener('click',event=>{if(performance.now()<suppressClickUntil){event.preventDefault();event.stopPropagation();}},true);
  track.addEventListener('scroll',onPosition,{passive:true});
  function step(direction){
    if(!originals.length)return;
    momentum=0;const gap=parseFloat(getComputedStyle(track).columnGap)||0;
    writePosition(drift+direction*(originals[0].getBoundingClientRect().width+gap));
  }
  track.addEventListener('keydown',event=>{
    if(event.target!==track)return;
    if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();step(event.key==='ArrowLeft'?-1:1);}
    if(['Home','End'].includes(event.key)){event.preventDefault();momentum=0;writePosition(event.key==='Home'?period:period*2-1);}
  });
  return {step,destroy(){cancelAnimationFrame(animationFrame);observer.disconnect();sizeObserver.disconnect();}};
}
function initializeProof(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const $=selector=>root.querySelector(selector);
  const photoTrack=$('[data-photo-track]'),reviewTrack=$('[data-review-track]');
  const words=JSON.parse($('[data-proof-words]').textContent);
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const lightbox=$('[data-lightbox-dialog]'),reviewDialog=$('[data-review-dialog]');
  const reviewCards=[...reviewTrack.children];
  const reviewPosition=$('[data-review-position]');
  function updateReviewPosition(){
    const step=(reviewCards[0]?.getBoundingClientRect().width||0)+(parseFloat(getComputedStyle(reviewTrack).columnGap)||0);
    const {first,last}=visibleReviewRange(reviewTrack.scrollLeft,reviewTrack.clientWidth,step,reviewCards.length);
    const format=first===last||last<first?words.singlePosition:words.position;
    const text=format.replace('[first]',first).replace('[last]',last).replace('[total]',reviewCards.length);
    if(reviewPosition.textContent!==text)reviewPosition.textContent=text;
    $('[data-reviews-prev]').disabled=reviewCards.length<2;$('[data-reviews-next]').disabled=reviewCards.length<2;
  }
  const blocked=()=>lightbox.open||reviewDialog.open;
  const photoLoop=createProofLoop(photoTrack,{speed:.026,reduced,blocked});
  const reviewLoop=createProofLoop(reviewTrack,{speed:.018,reduced,blocked,onPosition:updateReviewPosition});
  $('[data-gallery-prev]').addEventListener('click',()=>photoLoop.step(-1));
  $('[data-gallery-next]').addEventListener('click',()=>photoLoop.step(1));
  $('[data-reviews-prev]').addEventListener('click',()=>reviewLoop.step(-1));
  $('[data-reviews-next]').addEventListener('click',()=>reviewLoop.step(1));
  function openLightbox(link){
    const image=link.querySelector('img');
    $('[data-lightbox-image]').src=image.currentSrc||image.src;$('[data-lightbox-image]').alt=image.alt;$('[data-lightbox-caption]').textContent=image.alt;lightbox.showModal();
  }
  function openReview(card){
    const content=$('[data-review-dialog-content]');content.replaceChildren();
    for(const selector of ['.proof-review-author','.proof-stars','.proof-review-message','.proof-review-photos']){const original=card.querySelector(selector);if(original)content.append(original.cloneNode(true));}
    const source=card.querySelector('[data-google-source]').cloneNode(true);source.className='proof-maps-button';source.textContent=words.onGoogle;content.append(source);
    for(const node of content.querySelectorAll('[tabindex="-1"]'))node.removeAttribute('tabindex');
    reviewDialog.setAttribute('aria-label',words.reviewBy.replace('[author]',card.dataset.author));reviewDialog.showModal();
  }
  root.addEventListener('click',event=>{
    const image=event.target.closest('[data-proof-lightbox]');if(image){event.preventDefault();openLightbox(image);return;}
    const review=event.target.closest('[data-read-review]');if(review){openReview(review.closest('[data-review-card]'));return;}
    const close=event.target.closest('[data-close-proof-dialog]');if(close)close.closest('dialog').close();
  });
  for(const dialog of [lightbox,reviewDialog])dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  root.addEventListener('charm-proof-disconnect',()=>{photoLoop.destroy();reviewLoop.destroy();},{once:true});
}
document.querySelectorAll('[data-charm-proof]').forEach(initializeProof);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-charm-proof]').forEach(initializeProof));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-charm-proof]').forEach(root=>root.dispatchEvent(new Event('charm-proof-disconnect'))));
